import React from 'react';
import PropTypes from 'prop-types';
import styles from './PaymentInfoCTA.module.scss';

const PaymentInfoCTA = ({ cta }) => {
  return (
    <div className={styles.help}>Unable to pay with credit card? {cta}</div>

  );
};

PaymentInfoCTA.propTypes = {
  cta: PropTypes.node.isRequired,
};

export default PaymentInfoCTA;
